(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('room-type', {
            parent: 'entity',
            url: '/room-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.roomType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room-type/room-types.html',
                    controller: 'RoomTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roomType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('room-type-detail', {
            parent: 'entity',
            url: '/room-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.roomType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room-type/room-type-detail.html',
                    controller: 'RoomTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roomType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RoomType', function($stateParams, RoomType) {
                    return RoomType.get({id : $stateParams.id});
                }]
            }
        })
        .state('room-type.new', {
            parent: 'room-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-type/room-type-dialog.html',
                    controller: 'RoomTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('room-type', null, { reload: true });
                }, function() {
                    $state.go('room-type');
                });
            }]
        })
        .state('room-type.edit', {
            parent: 'room-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-type/room-type-dialog.html',
                    controller: 'RoomTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RoomType', function(RoomType) {
                            return RoomType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('room-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('room-type.delete', {
            parent: 'room-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-type/room-type-delete-dialog.html',
                    controller: 'RoomTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RoomType', function(RoomType) {
                            return RoomType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('room-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
